export const SET_CHAT_HEADER_TITLE = "SET_CHAT_HEADER_TITLE";
export const SET_CHAT_SUBTITLE = "SET_CHAT_SUBTITLE";
export const SET_CHAT_PARM_ENABLE_TEXT_AREA = "SET_CHAT_PARM_ENABLE_TEXT_AREA";
export const SET_CHAT_PARM_LANGUAGE = "SET_CHAT_PARM_LANGUAGE";
export const SET_CHAT_WIDGET_OPENED = "SET_CHAT_WIDGET_OPENED";
export const SET_UNREAD_MESSAGE_COUNT = "SET_UNREAD_MESSAGE_COUNT";
export const RENDER_CHAT = "RENDER_CHAT";
//
export const SET_CONNECT_SESSION = "SET_CONNECT_SESSION";
export const SET_CHAT_CONNECTED = "SET_CHAT_CONNECTED";
export const SET_CHAT_INITIAL_CONTACT_ID = "SET_CHAT_INITIAL_CONTACT_ID";
export const SET_CHAT_CURRENT_CONTACT_ID = "SET_CHAT_CURRENT_CONTACT_ID";
export const SET_MESSAGE_TO_SEND = "SET_MESSAGE_TO_SEND";
//
export const SET_ON_TYPING = "SET_ON_TYPING";
export const SET_IS_CHAT_ENABLED = "SET_IS_CHAT_ENABLED";
export const SET_MESSAGE_LIST = "SET_MESSAGE_LIST";
export const SET_IS_AGENT_CONNECTED = "SET_IS_AGENT_CONNECTED";
export const SET_SOUND_OFF = "SET_SOUND_OFF";
export const SET_DELIVERED_MESSAGE_ID = "SET_DELIVERED_MESSAGE_ID";
export const SET_READ_MESSAGE_ID = "SET_READ_MESSAGE_ID";
//
export const SET_ERROR = "SET_ERROR";
//
export const SET_IS_CUSTOMER_MESSAGE_IN_VIEW =
  "SET_IS_CUSTOMER_MESSAGE_IN_VIEW";
export const SET_RETRY_COUNTER = "SET_RETRY_COUNTER";
